<template>
  <div class="input_box">
    <label  class="left">{{item.label}}</label>
    <p v-show="showErrorMessage" class="errorMsg">{{errorMsg}}</p>
    <select v-model="value" v-on:blur="eventBlur"
            v-on:focus="eventFocus">
      <option :value="option.valueOption" v-for="option in item.selectOption">{{option.nameOption}}</option>
    </select>
  </div>
</template>

<script>
  import DataForInput from '@/gavnoCode/longFormOptions';
  import {mapGetters, mapState} from 'vuex';
  export default {
    name: "formSelect",
    data:function(){
      return {
        item: DataForInput[this.refs],
        isTimeToShowError: false
      }
    },
    props:{
      refs:{
        type:String,
        default:'null'
      },
      form:{
        type:String,
        default:'null'
      }
    },
    methods: {
      eventBlur: function () {
        this.isTimeToShowError = true;
      },
      eventFocus: function () {
        this.isTimeToShowError = false;
      }
    },
    computed:{
      status :function(){
        return this.statusVuex[this.form][this.refs].code;
      },
      errorMsg :function(){
        return this.statusVuex[this.form][this.refs].msg;
      },
      showErrorMessage:function(){
        return this.status != 0 && this.isTimeToShowError;

      },
      value:{
        get(){
          return this.valueVuex[this.form][this.refs];
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:this.refs,
            form:this.form,
            value: value
          });
        }
      },
      ...mapState({
        valueVuex: state => state.requestField.sendData,
        statusVuex: state => state.requestField.workData
      })
    }
  }
</script>

<style scoped>
  select {width: 100%;height: 30px;}
  .input_box label {text-align: left;display: block;}
  .errorMsg{color:red}
</style>
